import React, { Component, PropTypes } from 'react';
import NewCard from '../tc-ui/new-card';
import { TextField } from 'material-ui';
import { findDOMNode } from 'react-dom';

class SendEmailCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      moreText: false,
    };
  }

  componentDidMount() {
    const connectionsObj = this.props.tempConnections.get('connections').toJS();
    const connections = Object.values(connectionsObj);
    this.props.changeEmailValue(
      `Hi${ connections && connections.length === 1 && connections[0].firstName ? ` ${connections[0].firstName},` : ','}

Please connect with me on TourConnect, a private network built specifically for travel trade. It can help our existing partnership by allowing us to stay better connected with each other. We can easily share information & updates, contacts, marketing materials, and even automate rates and contracts. I look forward to connecting on TourConnect.`
    );

    const emailHeight = this.refs.emails ? findDOMNode(this.refs.emails).offsetHeight : 0;
    if (emailHeight > 100) this.setMoreText();
  }

  setMoreText = () => {
    this.setState({ moreText: true });
  };

  _getEmails = (connections) => {
    let emailString = '';
    let objectCount = 0;
    let maxHeight = '196px';
    let height = 'auto';
    let overflow = 'scroll';
    let more;
    const size = connections.size;
    const style = {
      lineHeight: '32px',
      width: '100%',
    };

    connections.forEach(connection => {
      objectCount++;
      emailString += connection.get('email');
      if (objectCount !== size) emailString += ', ';
    });

    if (this.state.moreText) {
      more = (
        <div
          className="send-email-more"
          style={{
            lineHeight: '48px',
            clear: 'both',
            cursor: 'pointer',
            overflow: 'auto',
            position: 'absolute',
            float: 'right',
            right: '0',
            bottom: '-8px',
          }}
          onClick={() => this.setState({ 'moreText': false })}
        >
        { '+ More' }
        </div>
      );
      maxHeight = '100px';
      height = '100px';
      overflow = 'hidden';
      style.width = '95%';
    }

    return (
      <div
        className="tc-card-header-title tc-new-card-header-title"
        style={{ overflowY: overflow, maxWidth: '100%', maxHeight, height, position: 'relative' }}
      >
        <div style={style} ref="emails">
        <div style={{ fontWeight: '600', fontSize: '14px', color: 'rgb(54%, 54%, 54%)', display: 'inline' }}>TO: </div>
        <div style={{ fontSize: '14px', color: 'rgb(54%, 54%, 54%)', display: 'inline' }}>{emailString}</div>
      </div>
      {more}
      </div>
    );
  };

  render() {
    if (!this.props.tempConnections.get('allInvitationsProcessed')) return false;
    const connections = this.props.tempConnections.get('connections');
    const emails = this._getEmails(connections);
    return (
      <NewCard className="send-email-card">
        {emails}
        <TextField
          fullWidth
          multiLine
          rows={5}
          onChange={event => this.props.changeEmailValue(event.target.value)}
          hintText="Enter an optional message..."
          value={this.props.tempConnections.get('emailValue')}
        />
      </NewCard>
    );
  }
}

SendEmailCard.propTypes = {
  tempConnections: PropTypes.object,
  changeEmailValue: PropTypes.func,
};

export default SendEmailCard;



// WEBPACK FOOTER //
// ./src/app/components/temp-connections/send-email-card.jsx